// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3dUH-","insightsList":"newBusinessInsightsMenu_insightsList__2IrTs","active":"newBusinessInsightsMenu_active__32W2D"};